<template>
  <div class="min-h-screen bg-white py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-primary mb-2">
          {{ $t("privacy.title") }}
        </h1>
        <p class="text-gray-500">
          {{ $t("privacy.last_updated") }}: {{ localizedDate }}
        </p>
      </div>

      <div class="leading-relaxed space-y-10">
        <component :is="currentContent" />
      </div>

      <div class="text-center mt-16 text-sm text-gray-400">
        <p>Owned and operated by Artush Aleksanyan.</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Nuxt auto-imports computed, useI18n, and shallowRef
const { t, locale } = useI18n();

// 1. In Nuxt, components in the /components folder are auto-imported.
// We use 'shallowRef' behavior inside the computed.
const currentContent = computed(() => {
  if (locale.value === "hy") return resolveComponent("LegalPrivacyHy");
  if (locale.value === "ru") return resolveComponent("LegalPrivacyRu");
  return resolveComponent("LegalPrivacyEn");
});

// Assuming your composable is in /composables/useLocalizedDate.ts
const { localizedDate } = useLocalizedDate();

useSeoMeta({
  title: () => t("privacy.title"),
  ogTitle: () => t("privacy.title"),
  description: () => t("privacy.seo_description"),
  ogDescription: () => t("privacy.seo_description"),
  ogImage: "https://medium.am/logo.png",
  twitterImage: "https://medium.am/logo.png",
  ogType: "website",
  twitterCard: "summary",
});
</script>
